var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreationThumbnailZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 81",
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 81,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 81,
    fill: "#e5e6eb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 34 20.5 L 34 30.5 L 44 30.5 L 34 20.5 Z M 31.5 30.5 L 31.5 20.5 L 17.75 20.5 C 15.679 20.5 14 22.178 14 24.25 L 14 56.75 C 14 58.82 15.679 60.5 17.75 60.5 L 40.25 60.5 C 42.321 60.5 44 58.821 44 56.75 L 44 33 L 34.071 33 C 32.617 33 31.5 31.882 31.5 30.5 Z M 21.5 23 L 26.5 23 L 26.5 25.5 L 21.5 25.5 L 21.5 23 Z M 21.5 28 L 26.5 28 L 26.5 30.5 L 21.5 30.5 L 21.5 28 Z M 21.5 33 L 26.5 33 L 26.5 35.5 L 21.5 35.5 L 21.5 33 Z M 24.024 52.929 C 20.855 52.929 18.496 50.082 19.115 47.035 L 21.5 38 L 26.5 38 L 28.917 47.132 C 29.524 50.164 27.164 52.929 24.024 52.929 Z M 25.25 46.75 L 22.75 46.75 C 22.063 46.75 21.5 47.312 21.5 48 C 21.5 48.687 22.06 49.25 22.75 49.25 L 25.25 49.25 C 25.938 49.25 26.5 48.687 26.5 48 C 26.5 47.312 25.938 46.75 25.25 46.75 Z",
    fill: "#9fa2a5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreationThumbnailZip);
export default __webpack_public_path__ + "static/media/creation-thumbnail-zip.88cd550b829b67b29fa6a65178597fff.svg";
export { ForwardRef as ReactComponent };